/**
 * Stable key for YOUR REWARDS redemption state on `users.{uid}`.
 * Must stay in sync with reward objects in `rewardsToRedeem` (id or couponCode).
 */
export function rewardTilePersistenceKey(reward) {
  if (!reward || typeof reward !== 'object') return null;
  if (reward.id != null && String(reward.id).trim()) return `id:${String(reward.id).trim()}`;
  const code = reward.couponCode != null ? String(reward.couponCode).trim().toUpperCase() : '';
  return code ? `code:${code}` : null;
}
